export const black='#000000'
export const white='#ffffff'
export const grey='#888888'
export const lightgrey='#f2f3f4'
export const red='#D32528'
export const blue='#1E90FF'
export const login_bg_color='#F3F8FF'
export const header_color='#4172B6'
export const subscription_bg_color='#F3F8FF'
export const header_title_color='#4F79B4'
export const cdfontFamily='Lato, sans-serif'

export const reportBoyMid='/images/ReportBoyMid.png'

// Option 1 Flower - white & yellowish 
// export const accentColor='#D39F32'
// export const loginBGImage='/images/CDFlowerBG.png'
// export const cdtextcolor='#ffffff'
// export const navbarcolor='#FE6236'
// export const navbartextcolor='#ffffff'
// export const pagesbgcolor='#EFF5F8'

// Option 2 Fruit - white & redish 
// export const accentColor='#FE6236'
// export const loginBGImage='/images/CDFruitBG.png'
// export const cdtextcolor='#888888'
// export const navbarcolor='#FE6236'
// export const navbartextcolor='#000000'
// export const pagesbgcolor='#EFF5F8'

// Option 3 Kids in park 
// export const accentColor='#F5A324'
// export const loginBGImage='/images/CDKidsBG.png'
// export const cdtextcolor='#ffffff'
// export const navbarcolor='#FE6236'
// export const navbartextcolor='#ffffff'
// export const pagesbgcolor='#EFF5F8'

// Option 4 Kids play 
export const accentColor='#E71D37'
export const loginBGImage='/images/CDKidsPlayBG.png'
export const cdtextcolor='#ffffff'
export const navbarcolor='#FE6236'
export const navbartextcolor='#ffffff'
export const pagesbgcolor='#EFF5F8'

// Option 5 Parent 
// export const accentColor='#E71D37'
// export const loginBGImage='/images/CDParentBG.png'
// export const cdtextcolor='#ffffff'
// export const navbarcolor='#FE6236'
// export const navbartextcolor='#ffffff'
// export const pagesbgcolor='#EFF5F8'

// Option 6 Mountains 
// export const accentColor='#E71D37'
// export const loginBGImage='/images/CDMountainsBG.png'
// export const cdtextcolor='#ffffff'
// export const navbarcolor='#FE6236'
// export const navbartextcolor='#ffffff'
// export const pagesbgcolor='#EFF5F8'

// Option 7 Leaf 1 
// export const accentColor='#2B3D18'
// export const loginBGImage='/images/CDLeafBG.png'
// export const cdtextcolor='#888888'
// export const navbarcolor='#FE6236'
// export const navbartextcolor='#ffffff'
// export const pagesbgcolor='#EFF5F8'

// Option 8 Leaf 2 
// export const accentColor='#2B3D18'
// export const loginBGImage='/images/CDLeaf2BG.png'
// export const cdtextcolor='#888888'
// export const navbarcolor='#FE6236'
// export const navbartextcolor='#ffffff'
// export const pagesbgcolor='#EFF5F8'
